import React from "react";

type Tone = "neutral" | "brand" | "success" | "danger" | "warning" | "info" | "purple";

const TONE: Record<Tone, string> = {
  neutral: "bg-bg text-textLight border-border",
  brand: "bg-brand/10 text-brand border-brand/20",
  success: "bg-success-bg text-success-text border-success-text/20",
  danger: "bg-danger-bg text-danger-text border-danger-text/20",
  warning: "bg-warning-bg text-warning-text border-warning-text/20",
  info: "bg-info-bg text-info-text border-info-text/20",
  purple: "bg-purple-bg text-purple-text border-purple-text/20",
};

export function Badge({
  tone = "neutral",
  children,
  className = "",
}: {
  tone?: Tone;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={`inline-flex items-center gap-xs px-sm py-[2px] rounded-full text-xs font-medium border ${TONE[tone]} ${className}`}
    >
      {children}
    </span>
  );
}

export type Detection = "detected" | "not_detected" | "inconclusive";

export function DetectionBadge({ value }: { value: Detection }) {
  if (value === "detected")
    return <Badge tone="danger">Detected</Badge>;
  if (value === "inconclusive")
    return <Badge tone="warning">Inconclusive</Badge>;
  return <Badge tone="success">Not detected</Badge>;
}

export function DeviceStatusBadge({
  online,
  hasError,
}: {
  online: boolean;
  hasError?: boolean;
}) {
  if (hasError) return <Badge tone="danger">Error</Badge>;
  return online ? <Badge tone="success">Online</Badge> : <Badge tone="neutral">Offline</Badge>;
}
